import React from 'react'
import { persistStore } from 'redux-persist-immutable'
import { SLASH } from '@lacele/const'
import { makePath } from '@lacele/utils'
import View from './view'
import store from './store'
import { dynamicReducer } from './reducer'

const PERSIST_STORE_KEY_PREFIX = 'it.lacele.pb'

export class App extends React.Component {

    constructor(props) {
        super(props)
        this.onInizialized = this.onInizialized.bind(this)
        persistStore(store, {
            // blacklist: ['xxx'],
            // debounce: 1000,
            keyPrefix: makePath(PERSIST_STORE_KEY_PREFIX, process.env.PUBLIC_URL, SLASH)
        }, this.onInizialized)
    }

    onInizialized() {
        this.setState({
            isInitialized: true
        })
    }

    render() {
        const props = { ...this.props, ...this.state }
        return (
            <View
                {...props}
                store={store}
                dynamicReducer={dynamicReducer}
            />
        )
    }
}
